export function basicTask() {
	const backTop = document.querySelector(".back-to-top");
	const counterItem = document.querySelectorAll(".counter");
	const setBackground = document.querySelectorAll("[setBackground]");
	const menuToggle = document.querySelector(".site-menu-toggle");
	const closeMenu = document.querySelector(".close-menu");
	const searchToggle = document.querySelector(".search-toggle");
	const closeSearch = document.querySelector(".close-search");
	const bodyWrap = document.querySelector("body");
	const menuMobile = document.querySelector(".mobile-nav-wrap");
	const searchWrap = document.querySelector(".search-overlay");
	const hamburger = document.querySelector(".hamburger");


	try {

		$(".tooltip").tooltipster({
			contentCloning: true,
			maxWidth: 320,
			minWidth: 280,
			interactive: true,
			trigger:
				/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
					navigator.userAgent
				)
					? "click"
					: "hover",
		});
	} catch (error) {

	}

	//Basic Toggle Function
	menuToggle.addEventListener("click", (e) => {
		e.preventDefault();
		menuMobile.classList.toggle("is-open");
		hamburger.classList.toggle("is-active");
		bodyWrap.classList.toggle("overlay-bg");
	});
	closeMenu.addEventListener("click", () => {
		menuMobile.classList.remove("is-open");
		hamburger.classList.remove("is-active");
		bodyWrap.classList.remove("overlay-bg");
		bodyWrap.classList.toggle("overlay-background");
	});

	// Search Toggle
	searchToggle.addEventListener("click", () => {
		searchWrap.classList.toggle("is-open");
		bodyWrap.classList.toggle("overlay-background");
	});
	// // Search Toggle
	// closeSearch.addEventListener("click", () => {
	// 	searchWrap.classList.remove("is-open");
	// 	bodyWrap.classList.remove("overlay-bg");
	// });

	//back to top
	backTop.addEventListener("click", (event) => {
		event.preventDefault();
		$("html, body").animate({ scrollTop: 0 }, "300");
	});
	$(".menu-item > a").wrap("<div class='title'></div>");
	$(".menu-item-has-children .title").append("<div class='icon'></div>");
	//Tab function
	if ($(window).width() < 1200.1) {

		$(".menu-item-has-children .title .icon").on("click", function () {
			$(this).parent().next().slideToggle();
			$(this).parent().toggleClass('is-active');
		});
	}
	//Tab function
	$(".rolling-text").each(function () {
		const $element = $(this);
		const innerText = $element.text().trim();
		$element.empty();

		const createTextContainer = () =>
			$("<div>")
				.addClass("block")
				.append(
					[...innerText].map((letter) =>
						$("<span>")
							.addClass("letter")
							.text(letter.trim() === "" ? "\xa0" : letter)
					)
				);

		$element.append(createTextContainer()).append(createTextContainer());
	});
	$(".toggle-wrap").each(function (index, element) {
		let $this = $(this);
		$this.addClass("toggle-instance-" + index);
		$(".toggle-instance-" + index + " .toggle-item .title").click(function () {
			if ($(this).parent().hasClass("is-toggle")) {

				$(this).parent().find(".article").slideUp();
				$(this).parent().removeClass("is-toggle");
			} else {
				$(".toggle-item").find(".article").slideUp();
				$(".toggle-item").removeClass("is-toggle");
				$(this).parent().find(".article").slideDown();
				$(this).parent().addClass("is-toggle");
			}
		});
	});


	if ($(".sticky-nav").length) {
		$(".sticky-nav").scrollToFixed({
			zIndex: 99,
			marginTop: 120,
		});
	}

	$(window)
		.scroll(function () {
			var scrollDistance = $(window).scrollTop();
			// Assign active class to nav links while scolling
			$(".scroll-section-wrap .anchor-section-id").each(function (i) {
				if (
					$(this).position().top -
					$(".sticky-nav").outerHeight() -
					80 -
					1 <=
					scrollDistance
				) {
					$(".sticky-nav li.active").removeClass("active");
					$(".sticky-nav li").eq(i).addClass("active");
				}
			});
		})
		.scroll();
	$(".sticky-nav  a").on("click", function (event) {
		if (this.hash !== "") {
			let offset =
				$("header").outerHeight() + $(".sticky-nav").outerHeight();
			var hash = this.hash;
			$("html, body").animate(
				{
					scrollTop: $(hash).offset().top - offset,
				},
				800,
				function () {
					// window.location.hash = hash;
				}
			);
		} // End if
	});

	//Tab function
	$(".tab-nav a").on("click", function () {
		$(this).parents(".tab-nav").find("li").removeClass("active");
		$(this).parents("li").addClass("active");

		var tab = $(this).attr("data-type");
		$(this).parents("section").find(".tab-item").removeClass("active");
		$(this)
			.parents("section")
			.find("#" + tab)
			.addClass("active");
	});
	//Tab hover




	//setBackground
	setBackground.forEach((attributes) => {
		attributes.style.cssText = `
		background-image: url(${attributes.getAttribute("setBackground")});
		background-size: cover;
		background-position: center;
	  `;
	});
	if (counterItem !== null) {
		if (counterItem.length) {
			const counterUp = window.counterUp.default;
			const callback = (entries) => {
				entries.forEach((entry) => {
					const el = entry.target;
					if (
						entry.isIntersecting &&
						!el.classList.contains("is-visible")
					) {
						counterUp(el, {
							duration: 2000,
							delay: 200,
						});
						el.classList.add("is-visible");
					}
				});
			};
			const IO = new IntersectionObserver(callback, { threshold: 1 });

			counterItem.forEach((counter) => {
				IO.observe(counter);
			});
		}
	}
}
